import type { RouteRecordRaw } from 'vue-router';

/** Entries rendered as a plain link instead of a button-like menu item. */
export const isTextMenuRoute = (route: RouteRecordRaw) => !!route.meta?.textOnly;

/**
 * Text-only entries are trailing actions ("exit POS mode"), so they always sink
 * to the end of their section no matter where they sit in the route tree.
 * Sorting is stable, so everything else keeps its declared order.
 */
export const sortMenuRoutes = <T extends RouteRecordRaw>(routes: T[]): T[] =>
  [...routes].sort((a, b) => Number(isTextMenuRoute(a)) - Number(isTextMenuRoute(b)));
